import { createFileRoute } from '@tanstack/react-router';
import { QuickConversionForm } from '../../../features/production-packconv/components/QuickConversionForm';

/** "Quick conversion" (Stuart ruling 2026-08-26): Howick's ~8 conversions/day
 * (e.g. kiln drying) are estimated via the stage's active recipe's historic
 * ratio, not weighed in/out. One screen, one typed number — see
 * QuickConversionForm's own header comment for the full rationale. Same thin
 * route-wrapper shape as `index.tsx`'s "Record a shift" (component IS the
 * feature component; no extra layout here). */
export const Route = createFileRoute('/_authenticated/production-packconv/quick')({
  component: QuickConversionForm,
});
